module.exports = __webpack_public_path__ + "img/shoot_00009.44824d90.png";